import { $ } from '@/Engine/state';
import { Shelf } from '@/Interfaces/common';
import { RackModule } from '@/Engine/Wardrobe/RackModule';

export function attachShelf(shelf: Shelf, rack: RackModule) {
    const oldRackModule = shelf.rackModule;
    if (!oldRackModule) {
        console.warn('При стыковке к модулю у полки не оказалось своего модуля');
        return false;
    }
    const oldRailGroup = oldRackModule.railGroup;
    if (!oldRailGroup) {
        console.warn('При стыковке к модулю у модуля полки не оказалось своего рельса');
        return false;
    }

    $.wardrobe.removeModuleByUUID(oldRackModule.uuid);
    shelf.rackModule = rack;
    shelf.position = rack.position;

    return true;
}

export function detachShelf(shelf: Shelf) {
    const oldModule = shelf.rackModule;
    shelf.rackModule = undefined;
    let rackModule;
    if (!oldModule) {
        console.warn('При отстыковки у полки отсутствует модуль');
        return;
    }
    if (!oldModule.railGroup) {
        console.warn('При отстыковки у модуля полки отсутствует рельс');
        return;
    }

    [ $.tempModule, rackModule ] = $.wardrobe.addModuleForShelf(shelf.raw, [], shelf);
    rackModule.railGroup = oldModule.railGroup;
    rackModule.position.y = oldModule.position.y;
    rackModule.railGroup.update();
}
